import { useUserActiveOrganization, useSubscriptionOffers } from "@/api";
import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";
import { Eye, EyeOff, Plus } from "lucide-react";
import { useState } from "react";
import { useSubscriptionOfferTableData } from "../../hooks/useSubscriptionOfferTableData";
import { SubscriptionOffersTable } from "./SubscriptionOffersTable";

export function SubscriptionOffers() {
  const [filterNonPending, setFilterNonPending] = useState(false);
  const { activeOrganization } = useUserActiveOrganization();
  const { data, loading, error } = useSubscriptionOffers(
    activeOrganization?.slug
  );
  const subscriptionOffersData = useSubscriptionOfferTableData(
    data,
    filterNonPending
  );

  return (
    <div>
      <div className="flex justify-end items-center gap-3 mb-6 mt-3 w-full">
        <TypographySM className="w-full text-brand-gray-800 dark:text-brand-gray-200">
          Subscription offers provide an offer for access to an app through a
          free or paid subscription format.
        </TypographySM>
        <Button
          variant="ghost"
          onClick={() => setFilterNonPending((prev) => !prev)}
          className="text-xs"
          data-testid="filterNonPending"
        >
          {filterNonPending ? (
            <EyeOff className="mr-2 h-4 w-4" />
          ) : (
            <Eye className="mr-2 h-4 w-4" />
          )}
          Filter non-pending
        </Button>
        <Link
          to="/organization/$organizationSlug/subscriptions/create-subscription-offer"
          params={{ organizationSlug: activeOrganization?.slug || "" }}
        >
          <Button variant="outline">
            <Plus className="mr-2 h-4 w-4" />
            Create subscription offer
          </Button>
        </Link>
      </div>
      <SubscriptionOffersTable
        data={subscriptionOffersData}
        loading={loading}
        error={error}
      />
    </div>
  );
}
